import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {ExchangeSearchParamType} from "../../pages/main/exchange/detail/interface";
import {ExchangeCreateType} from "../../pages/main/exchange/create/interface";

const url = "api/home/exchange/";

export async function readExchangeRate(param: ExchangeSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_exchange_rate", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadExchangeRateExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_exchange_rate_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function createExchangeRate(data: ExchangeCreateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_exchange_rate", data);
    } catch (err: any) {
        return err?.response;
    }
}
